import { Backdrop, Box, Button, Card, CardContent, CardHeader, Checkbox, Container, Divider, Grid, IconButton, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import Pagination from '@material-ui/lab/Pagination';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { getTasksRequest } from '../../store/actions/taskActions';
import logger from 'src/utils/logger';
import { normalizeResponseData, getFieldValue } from 'src/utils/normalizeData';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  rootPaper: {
    flexGrow: 1,
    padding: theme.spacing(2, 1),
    display: 'flex'
  },

  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },

}));

const DealerVisit = () => {
  const classes = useStyles();
  const SessionUser = getUser();
  const ServiceShopCode = SessionUser?.ServiceShopCode;

  const [ServiceCreditLimits, setServiceCreditLimits] = useState([]);
  const [serviceCreditLimitLogs, setServiceCreditLimitLogs] = useState([]);

  const [selectedRows, setSelectedRows] = useState({});
  const [totals, setTotals] = useState({});

  const [page, setPage] = useState(1);
  const maxTableCountsPerPage = 3;
  const pageCount = Math.ceil(Object.entries(ServiceCreditLimits).length / maxTableCountsPerPage);

  const [pageLogs, setPageLogs] = useState(0);
  const [rowsPerPageLogs, setRowsPerPageLogs] = useState(10);

  const [logsLoading, setLogsLoading] = useState(false);
  const [Loading, setLoading] = useState(false);
  const [generalLoading, setGeneralLoading] = useState(false);
  const [AlertMessage, setAlertMessage] = useState("");
  const [AlertType, setAlertType] = useState("success");
  const [AlertPopup, setAlertPopup] = useState(false);

  const [filterServiceCode, setFilterServiceCode] = useState("");
  const [filteredLogs, setFilteredLogs] = useState(serviceCreditLimitLogs);
  const [anchorEl, setAnchorEl] = useState(null);

  const openFilter = (e) => setAnchorEl(e.currentTarget);
  const closeFilter = () => setAnchorEl(null);

  React.useEffect(() => {
    if (!filterServiceCode.trim()) {
      setFilteredLogs(serviceCreditLimitLogs);
    } else {
      setFilteredLogs(
        serviceCreditLimitLogs.filter((row) =>
          row.SERVIS_KODU?.toString().toLowerCase().includes(filterServiceCode.toLowerCase())
        )
      );
    }
    handleChangePageLogs(null, 0);
  }, [filterServiceCode, serviceCreditLimitLogs]);

  const handleClear = () => setFilterServiceCode("");

  const handleGetUserBasedServiceCreditLimits = React.useCallback((data, groupedData) => {
    let serviceNumbersData = [];
    data.forEach(item => {
      const serviceCode = getFieldValue(item, 'ServiceShopCode');
      if (!serviceNumbersData.includes(serviceCode)) {
        serviceNumbersData.push(serviceCode);
      }
    });

    if (serviceNumbersData.length === 0) {
      const safeData = Object.keys(groupedData).reduce((acc, key) => {
        acc[key] = groupedData[key].map(item => ({
          ...item,
          WeeklyOrderAmount: 0,
          WeeklyMaxOrderAmount: 0,
          WeeklyRemainingOrderAmount: 0
        }));
        return acc;
      }, {});
      setServiceCreditLimits(safeData);
      return;
    }

    const limitData = {
      ServiceNumbers: serviceNumbersData.toString()
    };

    axios.post('/GetUserBasedServiceCreditLimits', limitData)
      .then((response) => {
        const limitResults = response?.data ?? [];

        if (Array.isArray(limitResults) && limitResults.length > 0) {
          limitResults.forEach(result => {
            if (groupedData[result.KUL_BIRIM_KODU]) {
              groupedData[result.KUL_BIRIM_KODU] = groupedData[result.KUL_BIRIM_KODU].map(item => ({
                ...item,
                WeeklyOrderAmount: result.HAFTALIK_SIPARIS_TUTARI,
                WeeklyMaxOrderAmount: result.KREDI_ONAY_UST_LIMIT,
                WeeklyRemainingOrderAmount: Math.max(
                  0.00,
                  result.KREDI_ONAY_UST_LIMIT - result.HAFTALIK_SIPARIS_TUTARI
                )
              }));
            }
          });
        } else {
          Object.keys(groupedData).forEach(key => {
            groupedData[key] = groupedData[key].map(item => ({
              ...item,
              WeeklyOrderAmount: 0,
              WeeklyMaxOrderAmount: 0,
              WeeklyRemainingOrderAmount: 0
            }));
          });
        }

        setServiceCreditLimits(groupedData);
      })
      .catch(error => {
        setGeneralLoading(false);
        const safeData = Object.keys(groupedData).reduce((acc, key) => {
          acc[key] = groupedData[key].map(item => ({
            ...item,
            WeeklyOrderAmount: 0,
            WeeklyMaxOrderAmount: 0,
            WeeklyRemainingOrderAmount: 0
          }));
          return acc;
        }, {});
        setServiceCreditLimits(safeData);
              logger.error("Hata detayı:", error.message);
      });
  }, []);

  const getAllServiceCreditLimits = React.useCallback(() => {
    setLoading(true);

    axios.get(`/GetServiceCreditLimits/${ServiceShopCode}`).then((response) => {
      const data = normalizeResponseData(response);

      const groupedData = data.reduce((acc, item) => {
        const key = getFieldValue(item, 'ServiceShopCode');
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item);
        return acc;
      }, {});

      // Servis Bazlı kalan limit hesaplamaları sorgulanıp final dataya eklenmektedir.
      handleGetUserBasedServiceCreditLimits(data, groupedData);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
            logger.error("Hata detayı:", error.message);
    });
  }, [ServiceShopCode, handleGetUserBasedServiceCreditLimits]);

  const getAllServiceCreditLimitLogs = React.useCallback(() => {
    setLogsLoading(true);

    axios.get(`/GetServiceCreditLimitsLogs/${ServiceShopCode}`).then((response) => {
      const data = response.data;
      setServiceCreditLimitLogs(data);
      setLogsLoading(false);
    }).catch(error => {
      setLogsLoading(false);
            logger.error("Hata detayı:", error.message);
    });
  }, [ServiceShopCode]);

  React.useEffect(() => {
    getAllServiceCreditLimits();
    getAllServiceCreditLimitLogs();
  }, [getAllServiceCreditLimits, getAllServiceCreditLimitLogs]);


  const handleApprove = () => {
    if (Object.values(selectedRows).flat().length <= 0) {
      setAlertMessage("Lütfen ilk önce sipariş seçiniz!...");
      setAlertType("error");
      setAlertPopup(true);
      return;
    }

    const selectedRowsList = Object.values(selectedRows).flat();
    for (const vbeln of selectedRowsList) {
      for (const serviceNumber in ServiceCreditLimits) {
        const row = ServiceCreditLimits[serviceNumber].find(item => 
          getFieldValue(item, 'Vbeln') === vbeln
        );
        if (row) {
          const totalSelectedAmount = ServiceCreditLimits[serviceNumber]
            .filter(item => selectedRows[serviceNumber]?.includes(getFieldValue(item, 'Vbeln')))
            .reduce((sum, item) => sum + (getFieldValue(item, 'Kwkkc') ?? 0), 0);

          const remainingLimit = (row.WeeklyRemainingOrderAmount ?? 0) - totalSelectedAmount;

          if (remainingLimit <= 0) {
            const serviceName = getFieldValue(row, 'ServiceName') || serviceNumber; // eğer isim varsa onu kullan, yoksa numara
            setAlertMessage(`Dikkat! ${serviceName} servisi için maksimum sipariş limitine ulaştınız!`);
            setAlertType("error");
            setAlertPopup(true);
            return;
          }
        }
      }
    }

    confirmAlert({
      message: "Onaylamak istediginizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleApproveYes()
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });
  };

  const prepareApprovalData = (selectedRows, creditLimitsData) => {
    const rowIndex = new Map(
      Object.values(creditLimitsData ?? {})
        .flat()
        .map(r => [getFieldValue(r, 'Vbeln'), r])
    );
    const selectedVbelns = Object.values(selectedRows ?? {}).flat();

    const selectedRowsData = selectedVbelns
      .map(vbeln => rowIndex.get(vbeln))
      .filter(Boolean);


    const grouped = selectedRowsData.reduce((acc, row) => {
      const serviceNumber = getFieldValue(row, 'ServiceShopCode');
      if (!acc[serviceNumber]) acc[serviceNumber] = [];
      acc[serviceNumber].push(row);
      return acc;
    }, {});

    const result = [];

    Object.entries(grouped).forEach(([, rows]) => {
      const krediSiparisToplam = rows.reduce(
        (sum, r) => sum + Number(getFieldValue(r, 'Kwkkc') || 0),
        0
      );
      const toplamKrediLimit = Number(getFieldValue(rows[0], 'EV_KREDI_LIMIT') || 0);
      const toplamBorc = Number(getFieldValue(rows[0], 'EV_BLOKAJSIZ_TUTAR') || 0);
      const kalanLimit = toplamKrediLimit - toplamBorc;
      const asmaToplam = Math.max(0, krediSiparisToplam - kalanLimit);

      rows.forEach(row => {
        result.push({
          ServiceShopId: String(getFieldValue(row, 'ServiceShopCode') ?? ""),
          ServiceShopName: getFieldValue(row, 'Name1') ?? "",
          SdDocumentNumber: getFieldValue(row, 'Vbeln'),
          SaOrderNumber: getFieldValue(row, 'Bstnk') ?? "",
          TotalCreditValue: (Number(getFieldValue(row, 'EV_KREDI_LIMIT'))).toFixed(2),
          TotalDebtValue: (Number(getFieldValue(row, 'EV_BLOKAJSIZ_TUTAR') ?? 0)).toFixed(2),
          CreditValue: (Number(getFieldValue(row, 'Kwkkc') ?? 0)).toFixed(2),
          HangingAmount: asmaToplam.toFixed(2),
          OrderDate: getFieldValue(row, 'Erdat') ?? "",
        });
      });
    });
    return result;
  }

  const handleApproveYes = () => {
    const selectedRowsList = Object.values(selectedRows).flat();
    const data = prepareApprovalData(selectedRowsList, ServiceCreditLimits);
    setLoading(true);
    axios.post('/SetApproveServiceCreditLimit', data).then((response) => {
      const data = response.data;
      if (data.ErrorCode === '0') {

        setAlertMessage("İşlem başarılı bir şekilde gerçekleştirildi.");
        setAlertType("success");
        setAlertPopup(true);

        // Onay işlemi sonucunda dip toplam siliniyor.
        setSelectedRows({});
        setTotals({});

        setLoading(false);
        getAllServiceCreditLimits();
        getAllServiceCreditLimitLogs();

      } else {

        setAlertMessage(data.ErrorDescription ?? "İşlem Sırasında bir hata oluştu.");
        setAlertType("error");
        setAlertPopup(true);
        setLoading(false);
      }
    }
    ).catch(error => {
      setAlertMessage("İşlem sırasında bir hata oluştu.");
      setAlertType("error");
      setAlertPopup(true);
      setLoading(false);
            logger.error("Hata detayı:", error.message);
    });

  }

  const handleCheckboxChange = (serviceNumber, row, checked) => {
    setSelectedRows(prevSelected => {
      const updated = { ...prevSelected };
      if (!updated[serviceNumber]) updated[serviceNumber] = [];

      const vbelnValue = getFieldValue(row, 'Vbeln');
      if (checked) {
        updated[serviceNumber] = [...updated[serviceNumber], vbelnValue];
      } else {
        updated[serviceNumber] = updated[serviceNumber].filter(
          vbeln => vbeln !== vbelnValue
        );
      }

      // Kullanıcı bazlı kalan limit = WeeklyRemainingOrderAmount - seçilen siparişlerin tutarı
      setServiceCreditLimits(prevData => {
        return {
          ...prevData,
          [serviceNumber]: prevData[serviceNumber].map(item => {
            // Seçilen satır ise bile hiçbir field'ı mutasyona uğratmıyoruz
            if (getFieldValue(item, 'Vbeln') === vbelnValue) {
              return {
                ...item,
                WeeklyRemainingOrderAmount: item.WeeklyRemainingOrderAmount  // orijinal değeri koru
              };
            }
            return item;
          })
        };
      });

      setTotals(prevTotals => {
        const selectedItems = ServiceCreditLimits[serviceNumber].filter(item => 
          updated[serviceNumber].includes(getFieldValue(item, 'Vbeln'))
        );

        const krediSiparisToplam = selectedItems.reduce((sum, r) => 
          sum + Number(getFieldValue(r, 'Kwkkc') || 0), 0
        );

        // Sabit olan servis bazlı Toplam Kredi Limit, Toplam Borç ve Kalan Kredi Limit
        const toplamKrediLimit = Number(getFieldValue(selectedItems[0], 'EV_KREDI_LIMIT') || 0);
        const toplamBorc = Number(getFieldValue(selectedItems[0], 'EV_BLOKAJSIZ_TUTAR') || 0);
        const kalanLimit = toplamKrediLimit - toplamBorc;

        const asmaToplam = Math.max(0, krediSiparisToplam - kalanLimit);

        return {
          ...prevTotals,
          [serviceNumber]: {
            KrediToplam: krediSiparisToplam,
            ToplamBorc: toplamBorc,
            AsmaToplam: asmaToplam
          }
        };
      });

      return updated;
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangePageLogs = (event, newPage) => {
    setPageLogs(newPage);
  };

  const handleChangeRowsPerPageLogs = (event) => {
    setRowsPerPageLogs(parseInt(event.target.value, 10));
    setPageLogs(0);
  };

  const formatCurrency = (value) => {
    const number = Number(value) || 0;
    return number.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + " ₺";
  };

  return (
    <Page className={classes.root} title={"Kredi Limit"}>
      <Container maxWidth="lg">
        <Header />
        {
          generalLoading ?
            <Backdrop className={classes.backdrop} open={generalLoading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        {
          AlertPopup ?
            <Alert onClose={() => setAlertPopup(false)} message={AlertMessage} variant={AlertType} />
            : <div></div>
        }
        <Card>
          <CardHeader
            title="Onaylanmayı Bekleyen Kredi Limitleri"
            action={
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                startIcon={<CheckIcon />}
                onClick={() => handleApprove()}
              >
                Onayla
              </Button>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                {Loading ? (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    <Box display="flex" justifyContent="flex-end" mb={2}>
                      <Pagination count={pageCount} page={page} onChange={handleChangePage} color="secondary" />
                    </Box>
                    <TableContainer>
                      {Object.entries(ServiceCreditLimits)
                        .slice((page - 1) * maxTableCountsPerPage, page * maxTableCountsPerPage)
                        .map(([serviceNumbers, items]) => (
                          <Box key={serviceNumbers} mb={3}>
                            <Table size="small" key={serviceNumbers} sx={{ mb: 2 }}>
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left" colSpan={9}>
                                    <Box display="flex" alignItems="center" mb={1}>
                                      <Typography variant="subtitle2">Servis Kodu:</Typography>
                                      <Chip
                                        label={serviceNumbers}
                                        size="small"
                                        variant="outlined"
                                        style={{
                                          fontWeight: "bold",
                                          marginLeft: 8,
                                          borderColor: "#FF9800",
                                          color: "#FF9800",
                                          cursor: "text",
                                        }}
                                      />
                                    </Box>

                                    <Box display="flex" alignItems="center">
                                      <Typography variant="subtitle2">Kalan Onay Limiti:</Typography>
                                      {(() => {
                                        const totalSelectedAmount = items
                                          .filter((item) => selectedRows[serviceNumbers]?.includes(getFieldValue(item, 'Vbeln')))
                                          .reduce((sum, item) => sum + (getFieldValue(item, 'Kwkkc') ?? 0), 0);

                                        const remainingLimit = (items[0]?.WeeklyRemainingOrderAmount ?? 0) - totalSelectedAmount;
                                        return (
                                          <Chip
                                            label={formatCurrency(remainingLimit)}
                                            size="small"
                                            variant="outlined"
                                            style={{
                                              fontWeight: "bold",
                                              marginLeft: 8,
                                              borderColor: remainingLimit > 0 ? "#01a90aff" : "#f44336",
                                              color: remainingLimit > 0 ? "#01a90aff" : "#f44336",
                                              cursor: "text",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              whiteSpace: "nowrap",
                                              fontVariantNumeric: "tabular-nums",
                                            }}
                                          />
                                        );
                                      })()}
                                    </Box>
                                  </TableCell>
                                </TableRow>

                                <TableRow>
                                  <TableCell align="center" width={100}></TableCell>
                                  <TableCell align="center" width={100}>Servis Kodu</TableCell>
                                  <TableCell align="center" width={300}>Servis Adı</TableCell>
                                  <TableCell align="center" width={150}>SA Sipariş Numarası</TableCell>
                                  <TableCell align="center" width={100}>Toplam Kredi Limiti</TableCell>
                                  <TableCell align="center" width={100}>Toplam Borç</TableCell>
                                  <TableCell align="center" width={100}>Sipariş Tutarı</TableCell>
                                  <TableCell align="center" width={100}>Aşma Tutarı</TableCell>
                                  <TableCell align="center" width={100}>Sipariş Tarihi</TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {items.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell align="center">
                                      <Checkbox
                                        checked={selectedRows[serviceNumbers]?.includes(getFieldValue(row, 'Vbeln')) || false}
                                        onChange={(e) => handleCheckboxChange(serviceNumbers, row, e.target.checked)}
                                      />
                                    </TableCell>

                                    <TableCell align="center" width={100}>
                                      {getFieldValue(row, 'ServiceShopCode') || "-"}
                                    </TableCell>

                                    <TableCell align="center" width={300}>
                                      {getFieldValue(row, 'Name1')}
                                    </TableCell>

                                    <TableCell align="center" width={150}>
                                      {getFieldValue(row, 'Bstnk')}
                                    </TableCell>

                                    <TableCell
                                      align="center"
                                      width={100}
                                      style={{ whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}
                                    >
                                      {formatCurrency(getFieldValue(row, 'EV_KREDI_LIMIT'))}
                                    </TableCell>

                                    <TableCell
                                      align="center"
                                      width={100}
                                      style={{ whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}
                                    >
                                      {formatCurrency(getFieldValue(row, 'EV_BLOKAJSIZ_TUTAR'))}
                                    </TableCell>

                                    <TableCell
                                      align="center"
                                      width={100}
                                      style={{ whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums" }}
                                    >
                                      {formatCurrency(getFieldValue(row, 'Kwkkc'))}
                                    </TableCell>

                                    <TableCell align="center" width={100}></TableCell>

                                    <TableCell align="center" width={100}>
                                      {moment(getFieldValue(row, 'Erdat')).format("DD/MM/YYYY")}
                                    </TableCell>
                                  </TableRow>
                                ))}

                                {/* Dip Toplam Satırı */}
                                <TableRow style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                                  <TableCell colSpan={4} align="right" style={{ fontWeight: "bold" }}>
                                    Seçili Toplam:
                                  </TableCell>
                                  <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                    {formatCurrency(getFieldValue(items[0], 'EV_KREDI_LIMIT'))}
                                  </TableCell>
                                  <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                    {formatCurrency(getFieldValue(items[0], 'EV_BLOKAJSIZ_TUTAR'))}
                                  </TableCell>
                                  <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                    {formatCurrency(totals[serviceNumbers]?.KrediToplam ?? 0)}
                                  </TableCell>
                                  <TableCell align="center" style={{ whiteSpace: "nowrap" }}>
                                    {formatCurrency(totals[serviceNumbers]?.AsmaToplam ?? 0)}
                                  </TableCell>
                                  <TableCell />
                                </TableRow>
                              </TableBody>
                            </Table>
                          </Box>
                        ))}
                    </TableContainer>

                    <Box display="flex" justifyContent="flex-end" mb={2}>
                      <Pagination count={pageCount} page={page} onChange={handleChangePage} color="secondary" />
                    </Box>
                  </>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <br />
        <br />
        <br />
        <br />
        <Card>
          <CardHeader title="Onaylanan Kredi Limitleri" />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                {logsLoading ? (
                  <div style={{ textAlign: 'center', padding: '20px' }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <>
                    <TableContainer>
                      <Table size="small" >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center" width={100}>No</TableCell>
                            <TableCell align="center" width={200}>
                              <Box display="flex" alignItems="center" justifyContent="center" style={{ whiteSpace: "nowrap" }}>
                                <span>Servis Kodu</span>
                                <IconButton size="small" onClick={openFilter} style={{ marginLeft: 4 }}>
                                  <SearchIcon fontSize="small" />
                                </IconButton>
                              </Box>
                              <Popover
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={closeFilter}
                                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                transformOrigin={{ vertical: "top", horizontal: "center" }}
                                PaperProps={{ style: { padding: 16, width: 260 } }}
                              >
                                <Box display="flex" flexDirection="column" gridGap={12}>
                                  <TextField
                                    autoFocus
                                    size="small"
                                    label="Servis Kodu"
                                    placeholder="Örn: 12345"
                                    value={filterServiceCode}
                                    onChange={(e) => setFilterServiceCode(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <IconButton size="small" onClick={handleClear}>
                                          <ClearIcon fontSize="small" />
                                        </IconButton>
                                      ),
                                    }}
                                  />
                                </Box>
                              </Popover>
                            </TableCell>
                            <TableCell align="center" width={300}>Servis Adı</TableCell>
                            <TableCell align="center" width={200}>SD Belge Numarası</TableCell>
                            <TableCell align="center" width={150}>SA Sipariş Numarası</TableCell>
                            <TableCell align="center" width={100}>Toplam Kredi Limiti</TableCell>
                            <TableCell align="center" width={100}>Toplam Borç</TableCell>
                            <TableCell align="center" width={100}>Sipariş Tutarı</TableCell>
                            <TableCell align="center" width={100}>Aşma Tutarı</TableCell>
                            <TableCell align="center" width={100}>Sipariş Tarihi</TableCell>
                            <TableCell align="center" width={100}>Onay Veren</TableCell>
                            <TableCell align="center" width={100}>Onay Tarihi</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {filteredLogs ? filteredLogs
                            .slice(pageLogs * rowsPerPageLogs, pageLogs * rowsPerPageLogs + rowsPerPageLogs)
                            .map((row, index) => (
                              <TableRow key={index}>
                                <TableCell align="center">{row.ID}</TableCell>
                                <TableCell align="center">{row.SERVIS_KODU}</TableCell>
                                <TableCell align="center">{row.SERVIS_ADI}</TableCell>
                                <TableCell align="center">{row.SD_BELGE_NUMARASI}</TableCell>
                                <TableCell align="center">{row.SA_SIPARIS_NUMARASI}</TableCell>
                                <TableCell
                                  align="center"
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {formatCurrency(row.KREDI_LIMITI)}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {formatCurrency(row.TOPLAM_BORC)}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {formatCurrency(row.KREDI_DEGERI)}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  {formatCurrency(row.ASMA_TUTARI)}
                                </TableCell>
                                <TableCell align="center">{row.SIPARIS_TARIHI ? moment(row.SIPARIS_TARIHI).format("DD/MM/YYYY") : "-"}</TableCell>
                                <TableCell align="center">{row.AD_SOYAD}</TableCell>
                                <TableCell align="center">{row.ONAY_TARIHI ? moment(row.ONAY_TARIHI).format("DD/MM/YYYY HH:mm:ss") : "-"}</TableCell>
                              </TableRow>
                            )) : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      component="div"
                      count={filteredLogs.length}
                      rowsPerPage={rowsPerPageLogs}
                      page={pageLogs}
                      onPageChange={handleChangePageLogs}
                      onRowsPerPageChange={handleChangeRowsPerPageLogs}
                    />
                  </>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}


export default connect(
  state => ({ tasks: state.tasks1 })
  ,
  {
    getTasksRequest
  }
)(DealerVisit);
